import { Link, useSidebarOpenState } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { BackstageTheme } from '@backstage/theme';
import { makeStyles, Typography } from '@material-ui/core';
import { appVersion } from './app-version';

const useStyles = makeStyles<BackstageTheme>(theme => ({
  root: {
    padding: theme.spacing(1, 3),
    color: theme.palette.navigation.color,
    opacity: 0.7,
    whiteSpace: 'nowrap',
  },
}));

export function AppVersion() {
  const classes = useStyles();
  const config = useApi(configApiRef);
  const { isOpen } = useSidebarOpenState();
  const build = appVersion(
    config.getOptionalString('app.buildInfo.version'),
    config.getOptionalString('app.buildInfo.commit'),
    config.getOptionalString('app.buildInfo.repository'),
  );

  if (!isOpen || !build) {
    return null;
  }

  return (
    <Typography component="div" variant="caption" className={classes.root}>
      <Link to={build.href} color="inherit">
        {build.label}
      </Link>
    </Typography>
  );
}
